<template>
  <span v-tooltip="{ data: uploadLocked ? uploadLockedLabel : 'Upload files' , arrowPosition: 'right'}">
    <Button :empty="empty" @click.prevent="onUploadClick" :disabled='uploadLocked' >
      <template>{{ uploadLocked ? 'Upload Files: locked' : 'Upload Files' }}</template>
    </Button>
    <input
      style="display:none"
      ref="uploadField"
      id="upl"
      type="file"
      multiple
      :accept="acceptedFiles"
      @change="onFilesChosen"
    />
    <upload-type
      ref="uploadModal"
      :files="filesToUpload"
      :type="trackType"
      @confirmed="startUpload"
    ></upload-type>
  </span>
</template>
<script>
import EventBus from "@/eventbus";
import Button from "@/components/common/Button.vue";
import {mapActions, mapState} from "vuex";
import UploadType from "./UploadType.vue";
import Constants from "@/store/constants";
import store from "@/store";
export default {
  name: "UploadButton",
  store,
  extends: Button,
  components: {UploadType},

  props: {
    empty: Boolean
  },
  data() {
    return {
      filesToUpload: [],
      // currentRouteName: null,
      // trackType: this.currentRouteName,
      fileType: null,
      uploadLocked: null,
      uploadLockedLabel: Constants.stationLockedLabel,
      acceptedFiles: Constants.acceptedAudioFiles
    };
  },
  computed: {
    trackType() {
      let currentRouteName = this.$route.path;
      const current = currentRouteName.split("/");
      return current[current.length - 1].toUpperCase();
    }
  },
  created() {
    // this.isStationLock(this.$route.params.stationUid);
    EventBus.$on("isStationLockedBus", this.getLockData);
    if (this.uploadLocked === null ){
      this.uploadLocked = this.uploadLockedStore();
    }

  },
  methods: {
    ...mapActions("uploads", ["performUpload"]),
    ...mapActions('tracks', ['isStationLock']),
    ...mapState('tracks', ['uploadLockedStore']),
    // onUploadClick: () => {
    //   EventBus.$emit("isStationLocked");
    // },
    GUID() {
      let u='',i=0;
      while(i++<36) {
        let c='xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'[i-1],r=Math.random()*16|0,v=c=='x'?r:(r&0x3|0x8);
        u+=(c=='-'||c=='4')?c:v.toString(16)
      }
      return u;
    },
    startUpload(files, type, boxList, royaltyFree) {
      console.log(files, type)
      console.log(type, boxList)
      this.performUpload({
        stationUid: this.$route.params.stationUid,
        files: files,
        trackType: type,
        linkToBoxes: boxList,
        SkipMetadataFetching: royaltyFree,
        SequenceIdentifier: this.GUID(),
        UploadCount: files.length,
      });

    },
    getLockData(value) {
      console.log(value)
      this.uploadLocked = value;
    },
    onFilesChosen(e) {
      if (!this.$refs.uploadField) return;
      this.filesToUpload = Array.from(this.$refs.uploadField.files);
      this.$refs.uploadModal.show();
      this.$refs.uploadField.value = null;
    },
    onUploadClick() {
      if (!this.$refs.uploadField) return;
      this.$refs.uploadField.click();
    }
  }
}

</script>

<style scoped>
</style>
